import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Popper from "@material-ui/core/Popper";
import Fade from "@material-ui/core/Fade";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import 'material-icons/iconfont/material-icons.css';
// import { usePopperTooltip } from "react-popper-tooltip";
// import "react-popper-tooltip/dist/styles.css";

import Sidebar from "../Sidebar";
import DashChart from "./DashChart";
import StatusCodeDetails from "./StatusCodeDetails";
import DashMap from "./DashGoogleMap";

import ScheduleImg from "../../assets/images/ico-schedule.svg";
import personImg from "../../assets/images/ico-person-blue.svg";
import statusRedImg from "../../assets/images/icon-lamp-status-red.svg";
import statusGrayImg from "../../assets/images/icon-lamp-status-gray.svg";
import statusGreenImg from "../../assets/images/icon-lamp-status-green.svg";
import errorNotifyImg from "../../assets/images/ico-bell-red.svg";

import { exportMaterialTableToExcel, exportMaterialTableToPDF, getDateString, timeConvertUtility } from "../../utilities/utility";
import { getPanelsStreetlightsInfoAction } from "../../actions/dashboard.action";
import {
  devicePhaseCode,
  deviceStatusCode,
  deviceModeCode,
  deviceErrorEventCode,
  typeFilter,
} from "../../constants/constants";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
} from "firebase/firestore";

// import {
//   init as initAddress,
//   getAllAddressAPICall,
//   getAddress,
//   getZones,
//   getWards,
//   isInitialized,
// } from "../Address";

// import { fetchAllDevices, getCounts, getDevices, isDeviceIdOn, init as initDevice, iterateDevices, setDeviceFilter, getDevicesByFilter } from "../../apis/dev_data";
import { db, getCheckSession } from "../../apis/auth";

import "../../styles/dashboard.scss";
import { Popover, Typography } from "@material-ui/core";
import DeviceDataService from "../../apis/device-data";
import LampDataService from "../../apis/lamps-data";
import DeviceAddressService from "../../apis/device-address";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import PoleDataService from "../../apis/pole-data";
import DashboardDataService from "../../apis/dashboard-data";
import { getSystemUpTimeData } from "../../query/device.query";
import { getTicketCount, updateZonesData } from "../../query/ticket.query";
import { AccessAlarm, CheckCircle } from '@mui/icons-material'; // Material UI icons (you can replace these with any icon you prefer)

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

// const zoneFilterList = [
//   {
//     label: "zone 1",
//     value: "zone 1",
//   },
//   {
//     label: "zone 2",
//     value: "zone 2",
//   },
//   {
//     label: "zone 3",
//     value: "zone 3",
//   },
// ];

const wardFilterList = [
  {
    label: "ward 1",
    value: "ward 1",
  },
  {
    label: "ward 2",
    value: "ward 2",
  },
  {
    label: "ward 3",
    value: "ward 3",
  },
];

const Dashboard = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const store = useStore();
  const dispatch = useDispatch();
  const isMounted = useRef(true);

  useEffect(() => {
    return () => { isMounted.current = false; };
  }, []);

  const [panelsStreetlightsInfoState, setPanelsStreetlightsInfoState] = useState({
    ...DeviceDataService.getInstance().getCounts()
  });


  const [dashboardErrorReportData, setDashboardErrorReportData] = useState([]);
  const [dashboardReportRawData, setDashboardReportRawData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [scheduledTime, setScheduledTime] = useState("");
  const [filterObj, setFilterObj] = useState({
    zone: 0,
    ward: 0,
    filter: typeFilter[0],
    error: 0,
  });
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [filterList, setFilterList] = useState([typeFilter[0], typeFilter[1], typeFilter[2]]);
  const [wardFilterList, setWardFilterList] = useState([]);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  // const [controlledVisible, setControlledVisible] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  // const [errorFilter, setErrorFilter] = React.useState(0);
  const [errorSelectList, setErrorSelectList] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  useEffect(() => {
    let timerId;
    const loadDashboardData = async () => {
      var sessionStatus = await getCheckSession();
      if (sessionStatus === false) {
        history.push("/");
        return;
      }
      await DashboardDataService.getInstance().initService();
      getScheduleInfoAPICall();
      var errorList = DeviceDataService.getInstance().getDeviceErrorSelectList();
      setErrorSelectList(errorList);

      await DeviceAddressService.getInstance().getAllAddressAPICall();
      await PoleDataService.initService();

      await DeviceDataService.getInstance().initService();
      await LampDataService.getInstance().initService();

      let zoneList = DeviceAddressService.getInstance().getZones();
      let wardList = DeviceAddressService.getInstance().getWards(zoneList[0].value);
      setZoneFilterList(zoneList);
      setWardFilterList(wardList);
      console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
      setFilterObj({
        zone: zoneList[0].value,
        ward: wardList[0].value,
        error: errorList[0].value,
      });

      const initServices = async () => {
        await DeviceDataService.getInstance().getScheduleData();
        await LampDataService.getInstance().getScheduleData();
        await DeviceDataService.getInstance().initService(onFetchComplete, null);
        await LampDataService.getInstance().initService(onFetchLampComplete, null);
      };
      initServices();

      const fetchTicketCount = async () => {
        try {
          const ticket = await getTicketCount().catch((e) => {
            console.log(e)
          });
          if (ticket != null) {
            setTicket(ticket);
          }
        } catch (error) {
          console.error("Error fetching ticket count:", error);
        }
      };
      fetchTicketCount();

      timerId = setInterval(() => {
        console.log(`[Dashboard] Running 60-second count refresh timer at ${new Date().toLocaleTimeString()}`);
        if (typeof DeviceDataService.getInstance().refreshSlcCounts === 'function') {
          DeviceDataService.getInstance().refreshSlcCounts();
        }
        if (typeof LampDataService.getInstance().refreshLampCounts === 'function') {
          LampDataService.getInstance().refreshLampCounts();
        }
        
        if (typeof onFetchComplete === 'function') {
          onFetchComplete();
        }

        const slcCounts = DeviceDataService.getInstance().getWorkingCCMS();
        const lampCounts = LampDataService.getInstance().getWorkingLampsCount();
        console.log(`[Dashboard] 1-min Refresh - SLCs: Total ${slcCounts?.slcCnt1} (ON: ${slcCounts?.slcOnCnt}, OFF: ${slcCounts?.slcOffCnt})`);
        console.log(`[Dashboard] 1-min Refresh - Lamps: Total ${lampCounts?.lmpCnt} (ON: ${lampCounts?.lmpOnCnt}, OFF: ${lampCounts?.lmpOffCnt})`);
        console.log(`[Dashboard] 1-min Refresh - ILMs: Total ${lampCounts?.ilmCnt} (ON: ${lampCounts?.ilmOnCnt}, OFF: ${lampCounts?.ilmOffCnt})`);
      }, 60000);
    };

    loadDashboardData();

    return () => {
      if (timerId) clearInterval(timerId);
    };
  }, []);

  const handleFilterChange = (e) => {
    const { target: { name = "", value = "" } = {} } = e;
    console.log(`handleFilterChange -> ${name} = ${value}`);
    if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value);
      setWardFilterList(wardList);
      console.log(`==> WardList = ${wardList}`);
      setFilterObj((prevState) => ({
        ...prevState,
        zone: value,
        ward: wardList[0].value,
      }));
    }
    else if (name === "ward") {
      setFilterObj((prevState) => ({
        ...prevState,
        ward: value,
      }));
    }
    else if (name === "filter") {
      setFilterObj((prevState) => ({
        ...prevState,
        filter: value,
      }));
    }
    else if (name == 'error-filter') {
      setFilterObj((prevState) => ({
        ...prevState,
        error: value,
      }));
      const { zone: zone = 0, ward: ward = 0, error: error = 0, filter: filter } = filterObj;
      // await DeviceDataService.getInstance().setDeviceFilter(zone, ward);
      // const { deviceList: deviceList = [], errorDeviceList: errorDeviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zone, ward);
      // updateDateSource(deviceList, errorDeviceList, getDeviceSummary());
      getDeviceList(zone, ward, value, filter);
    }
  };

  const handleFilterApply = async () => {
    // updateZonesData();
    onFetchComplete();
  };

  const panelsStreetlightsInfo = useSelector(
    (state) => state.dashboardReducer.panelsStreetlightsInfo
  );

  //Get user Info
  const getHeaderDetail = (propName) => {
    let configResponse = localStorage.getItem("firebaseConfigApiResponse");
    let detail = "";
    if (configResponse) {
      configResponse = JSON.parse(configResponse);
      switch (propName) {
        case "email":
        default: {
          detail = localStorage.getItem("userEmail") || "";
          break;
        }
        case "city": {
          detail = configResponse?.displayName;
        }
      }
    }
    return detail;
  };

  // <<<<<<< HEAD
  // const [ticket, setTicket] = useState([]);
  useEffect(() => {
    const fetchTicketCount = async () => {
      try {
        const ticket = await getTicketCount().catch((e) => {
          console.log(e)
        });
        if (ticket != null) {
          setTicket(ticket);
        }
      } catch (error) {
        console.error("Error fetching ticket count:", error);
      }
    };
    fetchTicketCount();
  }, []);
  // =======
  const [ticket, setTicket] = useState({
    assignedCount: 0,
    closedCount: 0
  });
  // >>>>>>> 3317c05a26a5eff779bfed35430af7ec73575f78

  const getScheduledTime = () => {
    const { onTime, offTime } = timeConvertUtility(scheduledTime);
    return `${onTime} - ${offTime}`;
  };

  const handlePopperClick = (e) => {
    setAnchorEl(e.currentTarget);
    setIsErrorDialogOpen(true);
  };

  const getDashboardColumnList = () => {
    return [
      {
        title: 'UID',
        field: "dev_id",
        sorting: false,
        searchable: true,
        render: ({ dev_id: ccmsNumber = "" }) => {
          return ccmsNumber;
        },
        exportTransformer: ({ dev_id: ccmsNumber = "" }) => {
          return ccmsNumber
        }
      },
      {
        title: 'Switch Number',
        // field: "dev_id",
        render: ({ sw_no: switchNo = "" }) => {
          return switchNo;
        },
        exportTransformer: ({ sw_no: switchNo = "" }) => {
          return switchNo
        }
      },
      {
        title: 'Ward',
        // field: "dev_id",
        render: ({ wd: ward = "" }) => {
          return ward;
        },
        exportTransformer: ({ wd: ward = "" }) => {
          return ward;
        }
      },
      {
        title: 'Phase',
        // field: "phase",
        sorting: false,
        searchable: false,
        render: ({ ph_cnt: phaseCode = 0 }) => {
          return devicePhaseCode[phaseCode];
        },
        exportTransformer: ({ ph_cnt: phaseCode = 0 }) => {
          return devicePhaseCode[phaseCode];
        },
      },
      {
        title: 'Location',
        // field: "location",
        sorting: false,
        searchable: false,
        render: (rowData) => {
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.addr != undefined && pole.addr != null) {
            return pole.addr;
          } else if (rowData.addr != undefined | null | "") {
            return rowData.addr;
          }
          return "N/A"
          // const {
          //   zn_id: zoneId = 0,
          //   wd_id: wardId = 0,
          //   pl_id: placeId = 0,
          //   st_id: streetId = 0,
          // } = rowData;
          // const {
          //   zone = "",
          //   ward = "",
          //   place = "",
          //   street = "",
          // } = DeviceAddressService.getInstance().getAddress(zoneId, wardId, placeId, streetId);
          // return `${place},${street}`;
          // return `${placeId},${streetId}`;
        },
        exportTransformer: (rowData) => {
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.addr != undefined && pole.addr != null) {
            return pole.addr;
          } else if (rowData.addr != undefined | null | "") {
            return rowData.addr;
          }
          return "N/A"
          // const {
          //   zn_id: zoneId = 0,
          //   wd_id: wardId = 0,
          //   pl_id: placeId = 0,
          //   st_id: streetId = 0,
          // } = rowData;
          // const {
          //   zone = "",
          //   ward = "",
          //   place = "",
          //   street = "",
          // } = DeviceAddressService.getInstance().getAddress(zoneId, wardId, placeId, streetId);
          // return `${place},${street}`;
          // return `${placeId},${streetId}`;
        }
      },
      {
        title: 'Lat/Long',
        // field: "coords",
        sorting: false,
        searchable: false,
        render: (rowData) => {
          let degreeSymbol = "\u00B0";
          let result = "";
          let latitude = 0;
          let longitude = 0;
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.loc != undefined && pole.loc != null) {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = pole;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else if (rowData.lloc != undefined | null) {
            const {
              lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          }
          if ((latitude === undefined | "") || (longitude === undefined | "")) {
            return "N/A"
          }
          if (latitude > 0) {
            result = `${latitude}${degreeSymbol}N`;
          } else {
            result = `${latitude}${degreeSymbol}S`;
          }
          if (longitude > 0) {
            result = `[${result}, ${longitude}${degreeSymbol}E]`;
          } else {
            result = `[${result}, ${longitude}${degreeSymbol}W]`;
          }
          return result;
        },
        exportTransformer: (rowData) => {
          let degreeSymbol = "\u00B0";
          let result = "";
          let latitude = 0;
          let longitude = 0;
          let pole = null;
          if (rowData.pid != undefined && rowData.pid != null) {
            pole = PoleDataService.getInstance().getPole(rowData.pid);
          }

          if (pole != null && pole.loc != undefined && pole.loc != null) {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = pole;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else if (rowData.lloc != undefined | null) {
            const {
              lloc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          } else {
            const {
              loc: { _lat: latitudeVal = 0, _long: longitudeVal = 0 } = {}
            } = rowData;
            latitude = latitudeVal;
            longitude = longitudeVal;
          }
          if (latitude > 0) {
            result = `${latitude}${degreeSymbol}N`;
          } else {
            result = `${latitude}${degreeSymbol}S`;
          }
          if (longitude > 0) {
            result = `[${result}, ${longitude}${degreeSymbol}E]`;
          } else {
            result = `[${result}, ${longitude}${degreeSymbol}W]`;
          }
          return result;
        },
      },
      {
        title: 'Status',
        // field: "status",
        sorting: false,
        searchable: false,
        render: ({ ccmsNumber: devId = "", status: statusCode = 0, errorsCount = 0 }) => {
          let element = null;
          if (DeviceDataService.getInstance().isDeviceIdOn(devId)) {
            element = statusGreenImg;
          } else {
            element = statusRedImg;
          }
          return <img src={element} />;
        },
        exportTransformer: ({ ccmsNumber: devId = "", status: statusCode = 0, errorsCount = 0 }) => {
          let element = null;
          if (DeviceDataService.getInstance().isDeviceIdOn(devId)) {
            element = 'ON';
          } else {
            element = 'OFF';
          }
          return element;
        },
      },
      {
        title: 'Error',
        // field: "errors",
        sorting: false,
        searchable: false,
        render: ({ dev_id: ccmsNumber = "", err_cnt: errorsCount = 0 }) => {
          return (
            <div>
              {errorsCount && (
                <div
                  className="pos-relative"
                  style={{ width: 40 }}
                  // ref={setTriggerRef}
                  // onClick={() => setControlledVisible(!controlledVisible)}
                  onClick={(e) => handlePopperClick(e)}
                >
                  <img src={errorNotifyImg} />
                  <div className="error-notify">
                    <span className="error-text-center">{errorsCount}</span>
                  </div>
                </div>
              )}
            </div>
          );
        },
        exportTransformer: ({ errors: errors = [] }) => {
          var list = errors?.map((errCode, i) => deviceErrorEventCode[errCode])
          return list.join(', ');
        },
      },
      {
        title: 'Mode',
        // field: "mode",
        sorting: false,
        searchable: false,
        render: ({ dev_md: mode = 0 }) => {
          return deviceModeCode[mode];
        },
        exportTransformer: ({ dev_md: mode = 0 }) => {
          return deviceModeCode[mode];
        },
      },
      {
        title: 'Last Seen',
        field: "ls",
        type: "datetime",
        defaultSort: "desc",
        sorting: true,
        searchable: false,
        render: ({ ls: dateVal = "" }) => {
          let result = "";
          if (dateVal?.seconds) {
            let date = new Date(dateVal.seconds * 1000);
            var year = date.toLocaleString("default", { year: "numeric" });
            var month = date.toLocaleString("default", { month: "2-digit" });
            var day = date.toLocaleString("default", { day: "2-digit" });
            var time = date.toLocaleString("default", { timeStyle: "short" });
            result = `${day}/${month}/${year} ${time}`;
          }
          return result;
        },
        exportTransformer: ({ ls: dateVal = "" }) => {
          let result = "";
          if (dateVal?.seconds) {
            let date = new Date(dateVal.seconds * 1000);
            var year = date.toLocaleString("default", { year: "numeric" });
            var month = date.toLocaleString("default", { month: "2-digit" });
            var day = date.toLocaleString("default", { day: "2-digit" });
            var time = date.toLocaleString("default", { timeStyle: "short" });
            result = `${day}/${month}/${year} ${time}`;
          }
          return result;
        },
      },
      {
        title: "Non-Glowing",
        // field: "nonGlowing",
        sorting: false,
        searchable: false,
        render: ({ lmp_cnt: lampCount = 0, lmp_off_cnt: lampOffCount = 0 }) => {
          return `${lampOffCount}/${lampCount}`;
        },
        exportTransformer: ({ lmp_cnt: lampCount = 0, lmp_off_cnt: lampOffCount = 0 }) => {
          return `${lampOffCount}/${lampCount}`;
        },
      },
    ];
  };

  const getScheduleInfoAPICall = async () => {
    let scheduleInfo = "";
    const q = query(
      collection(db(), "schedules"),
      where("name", "==", "default")
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      scheduleInfo = doc.data();
      console.log("schedule : ", scheduleInfo);
    });
    setScheduledTime(scheduleInfo);
    return;
  };

  // const fetchAllDevicesDashboard = async () => {
  //   let devices = DevideDataService.getInstance().getDevices();
  //   if (devices != null && devices.size > 0) {
  //     onFetchComplete();
  //   } else {
  //     await DevideDataService.getInstance().fetchAllDevices();
  //   }
  // };

  // function iterateDeviceHandler(record, changeType) {
  //   console.log(`========= Dashboard : iterateDeviceHandler() =========== record = ${JSON.stringify(record)}`);
  //   if (record != undefined) {
  //     let mapRawData = [...dashboardReportRawData];
  //     var reportIndex = mapRawData.findIndex(item => item.dev_id == record.dev_id);
  //     if (reportIndex >= 0) {
  //       if (changeType === "removed") {
  //         mapRawData.splice(reportIndex, 1);
  //       } else {
  //         mapRawData[reportIndex] = record;
  //       }
  //     } else {
  //       if (changeType != "removed") {
  //         mapRawData.push(record);
  //       }
  //     }

  //     let errorRawData = [...dashboardErrorReportData];

  //     if (record.err_cnt > 0) {
  //       var errorIndex = errorRawData.findIndex(item => item.dev_id == record.dev_id);
  //       if (errorIndex >= 0) {
  //         if (changeType === "removed") {
  //           errorRawData.splice(reportIndex, 1);
  //         } else {
  //           errorRawData[errorIndex] = record;
  //         }
  //       } else {
  //         if (changeType != "removed") {
  //           errorRawData.push(record);
  //         }
  //       }
  //     }
  //     updateDateSource(mapRawData, errorRawData, getDeviceSummary());
  //   }
  // }

  async function onFetchComplete() {
    console.log("====> Process onFetchComplete");
    const { zone: zone = 0, ward: ward = 0, error: error = 0, filter: filter } = filterObj;
    // await DeviceDataService.getInstance().setDeviceFilter(zone, ward);
    // const { deviceList: deviceList = [], errorDeviceList: errorDeviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zone, ward);
    // updateDateSource(deviceList, errorDeviceList, getDeviceSummary());
    getDeviceList(zone, ward, error, filter);
  }

  async function getDeviceList(zone, ward, error, filter) {
    console.log("====> Process onFetchComplete");
    var errorDeviceListResult = [];
    await DeviceDataService.getInstance().setDeviceFilter(zone, ward, 0, 0, filter);
    const { deviceList: deviceList = [], errorDeviceList: errorDeviceList = [] } = await DeviceDataService.getInstance().getNonSlcAndSlc(zone, ward, filter);
    // alert(deviceList.length)
    const lastSceneGap = 2; // in hours
    if (error != 0) {
      for (const device of deviceList) {
        var isError = false;
        if (error == 5001) {  // No communication
          var lastScene = device.ls;
          var date = (new Date().getTime() / 1000);
          var gap = 60 * 60 * lastSceneGap;
          console.log(`\n\n\n ====> No communication = ${date} - ${lastScene?.seconds} = ${date - lastScene?.seconds} > ${gap}\n\n`);
          if (device.errors?.includes(error)) {
            isError = true;
          } 
          // else if (lastScene != undefined && lastScene != null && (date - lastScene?.seconds) > gap) {
          //   isError = true;
          // }
          if (isError == true) {
            errorDeviceListResult.push(device);
          }
        }
         else
           if (device.err_cnt > 0 && device.errors?.includes(error)) { // All other errors
          errorDeviceListResult.push(device);
        }
      }
    } else {
      for (const device of deviceList) {
        var isError = false;
        var lastScene = device.ls;
        var date = (new Date().getTime() / 1000);
        var gap = 60 * 60 * lastSceneGap;
        // console.log(`\n\n ${device.dev_id}\nerrorCount = ${device.err_cnt}\nlastScene = ${lastScene}\n${date} - ${lastScene?.seconds} = ${gap}`);
        if (device.err_cnt > 0) {
          isError = true;
        } 
        // else if (lastScene != undefined && lastScene != null && (date - lastScene?.seconds) > gap) {
        //   isError = true;
        // }
        if (isError == true) { // All other errors
          errorDeviceListResult.push(device);
        }
      }
    }
    // alert(deviceList.length)
    // errorDeviceListResult.sort((item1,item2)=> (item1?.seconds ?? 0) - (item2?.seconds ?? -1));
    updateDateSource(deviceList, errorDeviceListResult, getDeviceSummary());
  }

  // function onUpdateLampHandler(record, changeType) {
  //   console.log(`========= Dashboard : onUpdateLampHandler() =========== record = ${JSON.stringify(record)}`);
  //   if (record != undefined) {
  //     updateDateSource(null, null, getDeviceSummary());
  //   }
  // }

  async function onFetchLampComplete() {
    updateDateSource(null, null, getDeviceSummary());
  }

  async function updateDateSource(deviceList, errorDeviceList, deviceSummary) {
    if (!isMounted.current) return;
    if (deviceSummary != null) {
      //Update device summary
      setPanelsStreetlightsInfoState({ ...deviceSummary });
    }

    if (deviceList !== null) {
      //Update device info for Map
      setDashboardReportRawData(deviceList);
    }

    if (errorDeviceList != null) {
      //Update device info for Error table
      setDashboardErrorReportData(errorDeviceList);
    }
    setIsDataLoading(false);
  }

  function getDeviceSummary() {
    var result = null;
    var slcCountObj = DeviceDataService.getInstance().getCounts();
    if (slcCountObj != null) {
      result = slcCountObj;
    }
    var lmpCountObj = LampDataService.getInstance().getCounts();

    if (lmpCountObj != null) {
      if (result == null) {
        result = lmpCountObj;
      } else {
        result.lmpCnt = lmpCountObj.lmpCnt;
        result.lmpOnCnt = lmpCountObj.lmpOnCnt;
        result.lmpOffCnt = lmpCountObj.lmpOffCnt;
        result.lmpErrCnt = lmpCountObj.lmpErrCnt;
      }
      result.ilmCnt = lmpCountObj.ilmCnt;
      result.ilmOnCnt = lmpCountObj.ilmOnCnt;
      result.ilmOffCnt = lmpCountObj.ilmOffCnt;
      result.ilmErrCnt = lmpCountObj.ilmErrCnt;
    }
    return result;
  }

  const { zone: zoneFilter = 0, ward: wardFilter = 0, error: errorFilter = 0, filter: filter = typeFilter[0] } = filterObj;

  return (
    // <Grid container>
    //   <Grid item xs={3} className="sidebar-wrapper">
    //     <Sidebar />
    //   </Grid>
    //   <Grid item xs={9} className="dashboard-wrapper">

    //   </Grid>
    // </Grid>

    <div className="dashboard">
      {/* <nav className="sidebar">
          <Sidebar />
        </nav> */}
      {/* <main className="main-content"> */}
      <Grid
        container
        className="main-header"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid className="font-bold">
          Dashboard,{" "}
          <span className="header-city">{getHeaderDetail("city")}</span> city
        </Grid>
        <Grid className="header-email">
          <span>{getHeaderDetail("email")}</span>
          <img src={personImg} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sm={3}  >
          <div className="dash-schedule">
            <img src={ScheduleImg} />
            <div className="dash-schedule-info">
              <span>Schedule</span>
              <span className="font-bold">{getScheduledTime()}</span>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} sm={4}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '5px',
            padding: '18px',
            display: 'flex',
            flexDirection: 'column',
            marginLeft: '5px',
            marginRight: '5px'
          }}>

            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0px', paddingLeft: '16px' }}>
              <span>Tickets</span>
            </div>
            <div className="dash-ticket-tag">
              <div className="box">Created: <span className="font-bold">{ticket?.assignedCount || 0}</span></div>
              <div className="box">Active : <span className="font-bold">{(ticket?.assignedCount || 0) - (ticket?.closedCount || 0)}</span></div>
              <div className="box">Closed : <span className="font-bold">{ticket?.closedCount || 0}</span></div>
            </div>
          </div>
        </Grid>
        {/* <Grid xs={12} sm={3}>
          <div className="dash-schedule">
             <div className="status-info" style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
                <AccessAlarm style={{ color: 'green', marginRight: '5px' }} />
                <span>Active</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CheckCircle style={{ color: 'red', marginRight: '5px' }} />
                <span>Closed</span>
              </div>
            </div>
          </div>
        </Grid> */}
        <Grid item xs={12} sm={5}>
          <div className="dash-zw-filter">
            {/* <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="filter-label">Filter</InputLabel>
              <Select
                labelId="filter-label"
                id="filter-outlined"
                name="filter"
                value={filter}
                onChange={handleFilterChange}
                label="Filter"
              >
                 {filterList.map((item) => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="zone-label">Zone</InputLabel>
              <Select
                labelId="zone-label"
                id="zone-outlined"
                name="zone"
                value={zoneFilter}
                onChange={handleFilterChange}
                label="Zone"
              >
                {/* <MenuItem value={"all"}>All</MenuItem> */}
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select
                labelId="ward-label"
                id="ward-outlined"
                name="ward"
                value={wardFilter}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              className="dash-apply-btn"
              onClick={handleFilterApply}
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>
      <DashChart
        apiResponseData={panelsStreetlightsInfoState}
        isDataLoading={isDataLoading}
      />
      <StatusCodeDetails
        panelsStreetlightsInfoState={panelsStreetlightsInfoState}
      />

      {dashboardReportRawData.length ? (
        <DashMap data={dashboardReportRawData} />
      ) : null}
      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title={`Error List (${dashboardErrorReportData.length} entries)`}
          columns={getDashboardColumnList()}
          data={dashboardErrorReportData}
          onRowClick={(evt, rowData) => {
            console.log("row click", evt, rowData);
            setSelectedRowData(rowData);
            // setIsErrorDialogOpen(true);
          }}
          components={{
            // Container: props => props.children,
            // Actions: ({ data }) => <button>hello world</button>,
            Actions: ({ data }) => {

              return (
                <div style={{ margin: 10 }} className="MuiFormControl-root MuiTextField-root MTableToolbar-searchField-20">
                  {/* <FormControl className={classes.formControl}> */}
                  {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
                  <Select
                    style={{ width: 250 }}
                    labelId="error-filter-label"
                    id="error-filter"
                    name="error-filter"
                    value={errorFilter}
                    onChange={handleFilterChange}
                  >
                    {errorSelectList.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>


                </div>
              )
            }
          }}
          options={{
            exportButton: true,
            exportAllData: true,
            exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Device Error Report-${getDateString()}`); },
            exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Device Error Report-${getDateString()}`, 8, 18); },
            //exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Device Error Report-${getDateString()}`,","),
            // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Device Error Report-${getDateString()}`),
            // grouping: true,
            search: true,
            selection: false,
            sorting: true,
            pageSize: 10,
            rowStyle: (rowData) => ({
              backgroundColor:
                rowData?.ccmsNumber === selectedRowData?.ccmsNumber
                  ? "#f0f2f4"
                  : "",
            }),
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: "Search",
              exportCSVName: "Export as Excel",
              exportPDFName: "Export as PDF",
            },
          }}
        />
      </div>
      {/* <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CellTowerIcon"><path d="m7.3 14.7 1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7M19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9s-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1s-1-5.1-2.9-7.1"></path><path d="M6.1 4.1 4.9 2.9C3 4.9 2 7.4 2 10s1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9s.8-4.3 2.4-5.9m10.6 10.6c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5zM14.5 10c0-1.38-1.12-2.5-2.5-2.5S9.5 8.62 9.5 10c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88m-4.17 8L12 13l1.67 5z"></path></svg>
      <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" style={{color:'green'}} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CellTowerIcon"><path d="m7.3 14.7 1.2-1.2c-1-1-1.5-2.3-1.5-3.5 0-1.3.5-2.6 1.5-3.5L7.3 5.3c-1.3 1.3-2 3-2 4.7s.7 3.4 2 4.7M19.1 2.9l-1.2 1.2c1.6 1.6 2.4 3.8 2.4 5.9s-.8 4.3-2.4 5.9l1.2 1.2c2-2 2.9-4.5 2.9-7.1s-1-5.1-2.9-7.1"></path><path d="M6.1 4.1 4.9 2.9C3 4.9 2 7.4 2 10s1 5.1 2.9 7.1l1.2-1.2c-1.6-1.6-2.4-3.8-2.4-5.9s.8-4.3 2.4-5.9m10.6 10.6c1.3-1.3 2-3 2-4.7-.1-1.7-.7-3.4-2-4.7l-1.2 1.2c1 1 1.5 2.3 1.5 3.5 0 1.3-.5 2.6-1.5 3.5zM14.5 10c0-1.38-1.12-2.5-2.5-2.5S9.5 8.62 9.5 10c0 .76.34 1.42.87 1.88L7 22h2l.67-2h4.67l.66 2h2l-3.37-10.12c.53-.46.87-1.12.87-1.88m-4.17 8L12 13l1.67 5z"></path></svg>
      <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LightbulbIcon"><path d="M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7"></path></svg>
      <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38"  style={{color:'green'}} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LightbulbIcon"><path d="M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7"></path></svg>
      <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LightIcon"><path d="M13 6.06V3h-2v3.06c-4.5.5-8 4.31-8 8.93C3 16.1 3.9 17 5.01 17H8c0 2.21 1.79 4 4 4s4-1.79 4-4h2.99c1.11 0 2.01-.9 2.01-2.01 0-4.62-3.5-8.43-8-8.93M12 15H5c0-3.86 3.14-7 7-7s7 3.14 7 7z"></path></svg>
      <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1wmkh38" style={{color:'green'}} focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="LightIcon"><path d="M13 6.06V3h-2v3.06c-4.5.5-8 4.31-8 8.93C3 16.1 3.9 17 5.01 17H8c0 2.21 1.79 4 4 4s4-1.79 4-4h2.99c1.11 0 2.01-.9 2.01-2.01 0-4.62-3.5-8.43-8-8.93M12 15H5c0-3.86 3.14-7 7-7s7 3.14 7 7z"></path></svg> */}
      <Popover
        id="error-notify-popover"
        placement="right"
        open={isErrorDialogOpen}
        onClose={() => {
          setIsErrorDialogOpen(false);
          setAnchorEl(null);
        }}
        anchorEl={anchorEl}
        disablePortal={false}
        modifiers={{
          arrow: {
            enabled: true,
          },
        }}
        transition
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {
          // <Typography sx={{ p: 2 }}>
          <ul>
            {selectedRowData?.errors?.map((errCode, i) => {
              return (
                <li key={errCode}> {deviceErrorEventCode[errCode]} </li>
              );
            })}
          </ul>
          // </Typography>
        }
        {/* {({ TransitionProps }) => (
            // <ClickAwayListener
            //   onClickAway={() => {
            //     setIsErrorDialogOpen(false);
            //     setAnchorEl(null);
            //   }}
            // >
            <Fade {...TransitionProps}>
              <Paper>
                <IconButton
                  aria-label="close"
                  className="dash-close-btn"
                  onClick={() => {
                    setIsErrorDialogOpen(false);
                    setAnchorEl(null);
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <ul>
                  {selectedRowData?.errors?.map((errCode, i) => {
                    return (
                      <li key={errCode}> {deviceErrorEventCode[errCode]} </li>
                    );
                  })}
                </ul>
              </Paper>
            </Fade>
            // </ClickAwayListener>
          )} */}
      </Popover>
    </div>

  );
};

export default Dashboard;
